import React, { useCallback, useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  name: 'Martina L.',
  photo: 'https://randomuser.me/api/portraits/women/44.jpg',
  text: 'No entendía nada de ventas digitales y en la charla me quedó clarísimo el paso a paso. ¡Ya estoy armando mi primer ebook!'
}, {
  name: 'Facundo R.',
  photo: 'https://randomuser.me/api/portraits/men/32.jpg',
  text: 'La mejor decisión fue entrar al grupo. La info que dan gratis otros te la cobran carísima. 100% recomendado.'
}, {
  name: 'Camila S.',
  photo: 'https://randomuser.me/api/portraits/women/68.jpg',
  text: 'Pensé que necesitaba miles de seguidores para vender. Me abrieron la cabeza con las estrategias de tráfico.'
}];
function Counter() {
  const [count, setCount] = useState(0);
  const [hasStarted, setHasStarted] = useState(false);
  const ref = useRef<HTMLSpanElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // Use native IntersectionObserver for reliability
    const observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && !hasStarted) {
        setHasStarted(true);
      }
    }, {
      threshold: 0.1
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasStarted]);
  useEffect(() => {
    if (!hasStarted) return;
    let start = 0;
    const end = 2500;
    const increment = end / 125; // ~2 seconds at 60fps
    const timer = setInterval(() => {
      start += increment;
      if (start >= end) {
        setCount(end);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [hasStarted]);
  return <span ref={ref} className="font-display text-whatsapp font-bold" data-id="element-84">
      +{count.toLocaleString()}
    </span>;
}
export function SocialProofSection() {
  return <section className="py-24 px-4 bg-dark" data-id="element-85">
      <div className="max-w-6xl mx-auto" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-87">
          <h2 className="font-display text-3xl md:text-5xl font-bold mb-4 text-white" data-id="element-88">
            <Counter data-id="element-89" /> personas ya están dentro
          </h2>
          <p className="text-gray-400 text-lg font-medium" data-id="element-90">
            Sumate a la comunidad más activa de ventas digitales
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-91">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-darkCard p-8 rounded-2xl border border-white/10" data-id="element-92">
              <div className="flex items-center gap-1 mb-6" data-id="element-93">
                {[...Array(5)].map((_, i) => <span key={i} className="text-gold text-xl" data-id="element-94">
                    ⭐
                  </span>)}
              </div>

              <p className="text-gray-300 mb-8 italic leading-relaxed font-medium" data-id="element-95">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-4" data-id="element-96">
                <img src={testimonial.photo} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover border-2 border-white/10" data-id="element-97" />
                <div data-id="element-98">
                  <p className="font-bold text-white" data-id="element-99">{testimonial.name}</p>
                  <p className="text-sm text-gray-500 font-medium" data-id="element-100">
                    Miembro de la comunidad
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}